import { render, staticRenderFns } from "./isolation-info.vue?vue&type=template&id=b299fc12&scoped=true&"
import script from "./isolation-info.vue?vue&type=script&lang=js&"
export * from "./isolation-info.vue?vue&type=script&lang=js&"
import style0 from "./isolation-info.vue?vue&type=style&index=0&id=b299fc12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b299fc12",
  null
  
)

export default component.exports